import { ReactNode } from 'react';
import { Box, Column } from '@tempmee/react';
import { CenteredSpinner } from '~/commonComponents';

interface IShiftOverviewListProps {
  isEmpty: boolean;
  isLoading: boolean;
  EmptyComponent: ReactNode;
  PaginationComponent?: ReactNode;
  children: ReactNode;
  dataCy?: string;
}

/**
 * Card-list layout for the Shift Overview tabs — the card-based replacement for
 * `DataGrid`. Mirrors the grid's empty/loading/pagination semantics without the
 * column header row.
 */
export const ShiftOverviewList = ({
  isEmpty,
  isLoading,
  EmptyComponent,
  PaginationComponent,
  children,
  dataCy,
}: IShiftOverviewListProps) => {
  if (!isLoading && isEmpty) {
    return (
      <Column width="100%" data-cy={dataCy} pb={6}>
        {EmptyComponent}
      </Column>
    );
  }

  if (isLoading) {
    return (
      <Box width="100%" pt={6} data-cy={dataCy}>
        <CenteredSpinner />
      </Box>
    );
  }

  return (
    <Column width="100%" gap={6} data-cy={dataCy}>
      {/* Cards keep the block's default max width (672px) and are centered in the tab. */}
      <Column width="100%" align="center" gap={4}>
        {children}
      </Column>
      {PaginationComponent}
    </Column>
  );
};
